import React from 'react';
import Helmet from 'react-helmet';

import DemoRequestFormContainer from '../components/containers/DemoRequestFormContainer';

const DemoRequest = () => (
  <div className="DemoRequest">
    <Helmet
      title="Request Demo"
    />

    <div className="DemoRequest__header">
      <div className="container">
        <h1>Get a Personal Demo of RadonEasy</h1>
      </div>
    </div>

    <div className="DemoRequest__body">
      <div className="container">
        <div className="card">
          <div className="card-body">
            <h6 className="card-subtitle mb-3 text-muted">Fill out the form and we'll contact you to schedule a 1-on-1 demo.</h6>
            <DemoRequestFormContainer />
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default DemoRequest;



// WEBPACK FOOTER //
// ./src/pages/demo-request.js